import React, { FC } from "react";
import { StyledHeading } from "./index.styled";

export const SectionHeading: FC<{ children: string }> = ({ children }) => (
  <StyledHeading level="h2" size="s">
    {children}
  </StyledHeading>
);
